import React from 'react';
import { connect } from 'react-redux';

import Row from './Row';
import { 
  RowFields
} from '../Constants';

const Table = ({ rowData }) => (
    <table>
        <tbody>

        <tr>
            <th>Bill Number</th>
            <th colSpan={2}>{"Dates of Service"}</th>
            <th>{RowFields.DateBillSent.placeholder}</th>
            <th>{RowFields.AmountPaid.placeholder}</th>
            <th>{RowFields.DatePaid.placeholder}</th>
        </tr>
        
        {rowData.map( (row, idx) => 
            <Row index={idx}
            type={row.rowType} 
            key={row.id}
            />
        )}

        </tbody>
    </table>
)

const mapStateToProps = state => ({
  rowData: state.interestForm.rowData
})

export default connect(
  mapStateToProps
)(Table);